import { Backdrop, Button, Fade, makeStyles, Modal } from "@material-ui/core";
import { useEffect } from "react";
import { useState } from "react";
import CustomAutoComplete from "../../../common/CustomAutoComplete";
import { updateObjectStateValue } from "../../../utils/FunctionHelpers";
import { addCandidatsToSelection, getAllCadidatSelections } from "../../Services/SelectionCandidatService";
import DialogDeleteCustom from "../../../components/DialogDeleteCustom/DialogDeleteCustom";

function getModalStyle() {
    const top = 0;
    const left = 0;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: "20px",
    },
    saveButton: {
        backgroundColor: "rgb(66, 186, 150)",
        color: "#FFF",
        fontWeight: 500,
        "&:hover, &:focus": {
            backgroundColor: "#389e7f",
            borderColor: "#359478",
        },
    },
    deleteButton: {
        color: "#FFF",
        backgroundColor: "rgb(239, 98, 98)",
        fontWeight: 500,
        marginLeft: "0.5em",
        "&:hover, &:focus": {
            backgroundColor: "rgb(220, 98, 98)",
            borderColor: "rgb(239, 98, 98)",
        },
    },
    plus: {
        fontWeight: 500,
        marginBottom: "0.2em",
    },
    buttonLabel: {
        paddingLeft: "0.4em",
        marginLeft: 0,
    },
    closeButton: {
        color: "#1b2a4e",
        backgroundColor: "#d9e2ef",
        borderColor: "#d9e2ef",
        marginLeft: "0.5em",
        fontWeight: "500",
    },
    modalTitle: {
        color: "rgb(17 122 167)",
    },
    buttonProgress: {
        color: "white",
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
}));

const ChooseSelectionModal = ({ children, selectedCandidats, snackbarShowMessage, history }) => {
    const [openModal, setOpenModal] = useState(false)
    const classes = useStyles()
    const [selectionData, setSelectionData] = useState({
        isLoading: false,
        data: [],
        label: "SELECTION",
        required: true,
        selection: null,
        errors: {}
    })

    const validate = async () => {
        let temp = {};
        temp.selection = selectionData.selection ? "" : "Le champ 'NOM DE LA SÉLECTION' est obligatoire."
        setSelectionData((prevState) => ({
            ...prevState,
            errors: { ...temp }
        }))
        return Object.values(temp).every((x) => x === "")
    };

    const loadSelections = () => {
        updateObjectStateValue(
            setSelectionData,
            { isLoading: true, data: [] }
        )
        getAllCadidatSelections('?archived=false').then(({ data }) => {
            updateObjectStateValue(
                setSelectionData,
                { isLoading: false, data: data.candidatsSelections }
            )
        }).catch(() => {
            snackbarShowMessage("Erreur de chargement des sélections.", "error", 4000)
        }).finally(() => {
            updateObjectStateValue(
                setSelectionData,
                { isLoading: false }
            )
        })
    }

    const handleClose = () => {
        setOpenModal(false)
    }

    const handleOpen = () => {
        setOpenModal(true)
    }

    const handleChange = (event) => {
        setSelectionData((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const handleSelectionChange = (selection) => {
        handleChange({
            target: {
                name: 'selection',
                value: selection
            }
        })
    }

    const handleFilterSelection = () => {
        if (validate() && selectionData.selection !== undefined) {
            history.push({
                pathname: `/selections/${selectionData.selection.id}/candidats/${selectedCandidats[0]}/view`,
                state: {
                    numbersTotalOfSelections: selectedCandidats.length,
                    candidatsInList: selectedCandidats,
                    candidatIndex: selectedCandidats.indexOf(selectedCandidats[0]),
                    filtering: true
                },
            });
        }
    }
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [loadToDelete, setLoadToDelete] = useState(false);

    const handleRemoveSelection = async () => {
        if (validate() && selectionData.selection !== undefined) {
            setLoadToDelete(true);

            await addCandidatsToSelection(selectionData.selection.id, {deletedCandidats: selectedCandidats, selectedCandidats: []})
                .then(({ data }) => {
                    snackbarShowMessage(data);
                })
                .catch(({ response }) => {
                    snackbarShowMessage(response.data.error.detail, "error", 4000);
                })
                .finally(() => {
                    handleCloseDialog();
                    handleClose();
                    setLoadToDelete(false);
                });
            
        }
    }

    const handleCloseDialog = () => {
        if (loadToDelete) {
          return;
        }
        setOpenDialogDelete(false);
    };
    const handleOpenDialog = () => {
        setOpenDialogDelete(true);
    }

    const dialogDeleteProps = {
        handleClose: handleCloseDialog,
        handleOpen: openDialogDelete,
        loading: loadToDelete,
        title: "Supprimer les Candidats de la sélection"
    }

    useEffect(() => {
        if (openModal) loadSelections()
        return () => {
            setSelectionData({
                isLoading: false,
                data: [],
                label: "SELECTION",
                required: true,
                selection: null,
                errors: {}
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal])

    const body = (
        <div style={getModalStyle} className={classes.paper}>
            <div className="modal-header">
                <h4 className={classes.modalTitle}>Affiner et ajouter à une Sélection existante</h4>
            </div>
            <div className="modal-body">
                <CustomAutoComplete listData={selectionData} errors={selectionData.errors} value={selectionData.selection} handleDataChange={handleSelectionChange} name="selection" />
            </div>
            <div className="modal-footer">
                <Button className={classes.saveButton} onClick={handleFilterSelection}>
                    Affiner la sélection
                </Button>
                <Button className={classes.deleteButton} onClick={handleOpenDialog}>
                    Supprimer
                </Button>
                <Button className={classes.closeButton} onClick={handleClose}>
                    Annuler
                </Button>
            </div>
        </div>
    );

    return (
        <>
            {children(handleOpen)}
            <Modal
                className={classes.modal}
                open={openModal}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={openModal}>{body}</Fade>
            </Modal>
            <DialogDeleteCustom 
                {...dialogDeleteProps} 
                handleDelete={() => handleRemoveSelection()} 
                label={`Voulez - vous vraiment supprimer les Candidats de la sélection ${selectionData.selection?.selectionName} ?`} 
            />
        </>
    );
}
export default ChooseSelectionModal